import * as React from 'react'
import {Form} from "../../../lib/sbhtml/form"
import {Group, Item} from "../../../lib/sbhtml/field"
import {Input} from "../../../lib/sbhtml/input"
import {Settings} from "./settings-form"
import {State} from "./app"
import {Notification} from "../../../lib/sbhtml/notification"

export type CallbackProps = {
	onUsernameChange: (username:string) => void
	onPasswordChange: (password:string) => void
	onSave: (settings:Settings) => void
}

export type DataProps = State

export type Props = CallbackProps & DataProps

export const SettingsForm = (props:Props) => {
	return <Form
		onSubmit={() => props.onSave(props.settings)}
		hasSave={true}
		isSubmitting={props.isSaving}>
		<Group heading="Settings">
			<div style={{maxWidth: "400px"}}>
				<Notification type="info">
					By providing a username and password for the single sign on process with <a href="http://myadvantage.com.au/">Wentworth Advantage</a>,
					members will be able to view Wentworth Advantage content in AO, without first having to first log in by navigating to <a href={props.publicUrl}>this link</a>.
				</Notification>
			</div>
			<Item label="Username">
				<Input value={props.settings.username} onChange={(value) => props.onUsernameChange(value)} />
			</Item>
			<Item label="Password">
				<Input value={props.settings.password} onChange={(value) => props.onPasswordChange(value)} />
			</Item>
		</Group>
	</Form>
}



// WEBPACK FOOTER //
// ./src/3rd party integration/wentworthadvantage/settings-form/presentation.tsx